<script>
    export default {
        data() {
            return {
                isActive: false
            }
        },
        methods: {
            toggle() {
                this.isActive = !this.isActive;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenu.vue